<template>
  <div class="board">
    <h1>掲示板</h1>

    <BoardSearch />

    <BoardPager />
    <BoardTable :refsMessage="refsMessage" />
    <BoardPager />

    <BoardForm id="anchor-board-form" @refsMessage="getRefsMessage" />
  </div>
</template>

<script>
import BoardSearch from './BoardSearch';
import BoardTable from './BoardTable';
import BoardPager from './BoardPager';
import BoardForm from './BoardForm';

export default {
  name: 'Board',
  components: { BoardSearch, BoardTable, BoardPager, BoardForm },
  data() {
    return {
      refsMessage: null,
    };
  },
  methods: {
    getRefsMessage(refs) {
      this.refsMessage = refs;
    },
  },
};
</script>

<style scoped>
</style>
